module.exports = __webpack_public_path__ + "img/sem-imagem.9021c3a7.jpg";